<template>
  <div class="contactWay">
    <!-- 地图 -->
    <!-- map -->
    <div class="baidumap" id="allmap"></div>
    <div class="contact-text">
      <h5>深圳市易联通达物流科技发展有限公司</h5>
      <p>Shenzhen E-link Logistics Technology Development Co,Ltd.</p>
      <p>电话：0755-86235167</p>
      <p>邮箱：223640822@qq.com</p>
      <p>地址：深圳市龙岗区平湖街道海源城国际金融中心T1栋1212-1213</p>
      <br>
    </div>
  </div>
</template>

<script>
export default {
  name: "contactWay",
  data() {
    return {};
  },
  mounted() {
    this.baiduMap();
  },
  methods: {
    baiduMap() {
      var map = new window.BMap.Map("allmap"); //创建地图
      map.enableScrollWheelZoom(); //启用滚轮放大缩小
      var point = new window.BMap.Point(114.132648, 22.688133); //设置地图位置
      map.centerAndZoom(point, 12);
      var marker = new window.BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*内容主体*/
.contact-text {
  text-align: left;
}

.contact-text p {
  font-size: 12px;
}
.contact-text {
  margin-bottom: 40px;
}
.baidumap {
  width: 100%;
  height: 210px;
  margin: 40px auto;
  margin-left: 5px;
}
.texts {
  position: relative;
  line-height: 1.4em;
  /* 3 times the line-height to show 3 lines */
  height: 4.2em;
  overflow: hidden;
}
.texts::after {
  content: "";
  font-weight: bold;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 0 20px 1px 45px;
  background: url(http://newimg88.b0.upaiyun.com/newimg88/2014/09/ellipsis_bg.png)
    repeat-y;
}
</style>



// WEBPACK FOOTER //
// src/components/contact/contactWay.vue